const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import ECheckinForm from 'App/config/usz/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/usz/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: undefined,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.usz.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: undefined,
    customMatomoClientId: undefined,
    bookAppointmentInfo: textMap.bookAppointmentInfoText,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
